<template>
  <div>
    <Row>
      <Col span="22">
        <div class="container_wang_resetPassword">
          <Form ref="formCustom" :model="formCustom" :rules="ruleCustom">
            <table>
              <tr>
                <td class="title" colspan="2">支付密码重置</td>
              </tr>
              <tr>
                <td>手机号</td>
                <td>
                  <span>{{formCustom.mobile}}</span>
                </td>
              </tr>
              <tr>
                <td>验证码</td>
                <td class="authcode">
                  <FormItem class="new" prop="captcha">
                    <Input v-model="formCustom.captcha"/>
                    <div class="captchaBox" @click="getCode">
                      <span v-if="!show">获取验证码</span>
                      <span v-if="show">{{count}}</span>
                    </div>
                  </FormItem>
                </td>
              </tr>
            </table>
          </Form>
          <my-button @confirm="submit">确定</my-button>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
  import ApiClient from "@/api/ApiClient";
  import MyButton from '@/components/MyButton'
    export default {
      name: "resetPayPassword",
      components:{
        MyButton,
      },
      data(){
        const validateAuthcode = (rule, value, callback) => {
          if (value === '') {
            return callback(new Error('验证码不能为空'));
          }else{
            callback();
          }
        };
        return {
          timer: null,
          count: 0,
          show: false,
          formCustom: {
            mobile: '',
            captcha: '',
            type:'reset_cash_password',
          },
          ruleCustom: {
            captcha: [
              {validator: validateAuthcode, trigger: 'blur'}
            ]
          }
        }
      },
      mounted(){
        this.formCustom.mobile = JSON.parse(window.sessionStorage.getItem('userName'))
      },
      methods:{
        getCode() {
          if(this.count===0){
            ApiClient.post('/commons/captcha/getCaptcha.do', this.formCustom, {silent: true}, true).then(data => {
            }).catch(data=>{
              this.$Message.error(data.message)
            });
            const TIME_COUNT = 60;
            if (this.timer === null) {
              this.count = TIME_COUNT;
              this.show = true;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--
                } else {
                  this.show = false;
                  clearInterval(this.timer);
                  this.timer = null
                }
              }, 1000)
            }
          }
        },
        submit(){
          this.$refs.formCustom.validate((valid) => {
            if (valid) {
              ApiClient.put('/desktop/customer/findCashPassword.do', this.formCustom,{silent: true}).then(data => {
                this.formCustom.captcha = '';
                this.$Message.success('您的支付密码重置成功，新的支付密码为：888888');
                this.$router.push({name:'index'})
              }).catch(data=>{
                this.formCustom.captcha = '';
                this.$Message.error(data.message)
              })
            }
          })
        }
      },
    }
</script>
<style scoped lang="less">
  @import '~@/app.less';

  .title {
    font-size: @small-f;
    font-weight: 700;
  }

  table {
    border-collapse: collapse;
    margin-left: 60px;
    margin-top: 16px;
    width: 100%;
  tr td {
    border: 1px solid #D8D8D8;
    height: 42px;
    padding-left: 20px;
  }
  tr td:nth-child(2n+1) {
    width: 17%;
  }
  tr td:nth-child(2n) {
    width: 57%;
  }
  }

  table tr:nth-child(1), table tr:nth-child(3), table tr:nth-child(5), table tr:nth-child(7) {
    background-color: #F6F6F5;
  }

  .captchaBox {
    cursor: pointer;
    position: absolute;
    left: 38.5%;
    top: 0;
    width: 10%;
    height: 32px;
    color: @theme-c;
    border: 1px solid @theme-c;
    border-radius: 4px;
    line-height: 32px;
    margin-left: 0.6%;
    text-align: center;
  }
</style>
<style>
  .container_wang_resetPassword .ivu-input {
    width: 50%;
    margin-left: -10px;
  }

  .container_wang_resetPassword .new .ivu-input {
    width: 39%;
    margin-left: -10px;
  }

  .container_wang_resetPassword button {
    margin-left: 46%;
    margin-top: 60px;
  }

  .container_wang_resetPassword .ivu-form-item {
    margin-bottom: 0;
  }

  .container_wang_resetPassword .ivu-form-inline .ivu-form-item {
    width: 100%;
  }

  .container_wang_resetPassword .ivu-form-item-error-tip {
    display: inline;
    position: static;
  }

  .container_wang_resetPassword .ivu-input-wrapper {
    width: auto;
    display: inline;
  }

  .container_wang_resetPassword .authcode .ivu-form-item-error-tip {
    position: absolute;
    left: 50%;
    top:15%
  }
</style>



// WEBPACK FOOTER //
// src/pages/myProfile/resetPayPassword.vue